import { useContext, useCallback } from 'react';
import { ZoneContext } from 'context/ZoneContext';
import { TimelineWrapper } from '../../Station.styled';
import StationIcon from 'components/common/StationIcon';
import { SubZoneStation } from './SubZoneStation';
import SubZoneExpandedView from './SubZoneExpandedView';
import { StationStatus } from 'pages/Map/types';
import { Description } from '../Description';
import { ReactComponent as Coaching } from '../../../../../../../../../../assets/icons/expand.svg';
import { SubZoneExpandIcon, SubZoneIconWrapper, SubZoneStationWrapper } from './SubZone.styled';
import { MapTourContext } from 'context/MapTourContext';
import { TourType } from 'pages/Map/components/MapTour';
import { zIndex } from 'theme/zIndex';
import { shouldIncreaseZIndexOfPathStation } from '../../../PathRenderer/PathDescription/utils';
import useMapSearch from 'hooks/search/useMapSearch';

type SubZoneProps = { station: SubZoneStation };
export const SubZone = ({ station }: SubZoneProps) => {
    const {
        setSelectedStation,
        activeStation,
        paths,
        selectedPath,
        expandedStation,
        setExpandedStation,
        expandedPathDescription,
        expandedDescriptionStation,
        setExpandedDescriptionStation,
        selectedStation
    } = useContext(ZoneContext);
    const stationStatus = station.getSubZoneContainerStatus(activeStation, paths, selectedStation);
    const { tour, isMapTour, isCurrentTourItem } = useContext(MapTourContext);
    const isDescriptionExpanded = expandedDescriptionStation?.id === station.id;
    const defaultZIndex = station.getDefaultZIndex(activeStation);
    const stationZIndex = isDescriptionExpanded ? station.getHoveredZIndex(defaultZIndex) : defaultZIndex;
    const { getSearchColor } = useMapSearch();

    const onDescriptionExpand = useCallback(() => {
        setExpandedDescriptionStation(station);
    }, []);

    const onDescriptionCollapse = useCallback(() => {
        setExpandedDescriptionStation(undefined);
    }, []);

    const onStationClick = useCallback(() => {
        setSelectedStation(station);
    }, [station, setSelectedStation]);

    const onExpandSubzone = useCallback(() => {
        setExpandedStation(station);
    }, [station, setExpandedStation]);

    if (station.isExpanded(expandedStation)) {
        return <SubZoneExpandedView station={station} />;
    }

    const timeline = station.getTimeline();
    const type = station.getType();
    const position = station.getAbsolutePosition();
    const activePath = selectedPath ? selectedPath : isMapTour ? tour?.path : undefined;
    const selectedPathIntersectionDirection = activePath ? station.getStationInterasectionDirectionForSelectedPath(activePath) : null;
    const style = {
        left: position.x - 8,
        top: position.y,
        zIndex: shouldIncreaseZIndexOfPathStation(station, paths, expandedPathDescription) ? zIndex.PathDescription : stationZIndex
    };
    const backgroundColor = getSearchColor(station.id, station) || station.getStationColor(stationStatus);
    return (
        <SubZoneStationWrapper style={style} id={station.id} isMapTourActiveElement={isCurrentTourItem(TourType.INFO_ABOUT_STATIONS)}>
            <SubZoneIconWrapper
                style={{ backgroundColor }}
                selectedPathIntersectionDirection={selectedPathIntersectionDirection}
                isPathSelectedInTour={isCurrentTourItem(TourType.INFO_ABOUT_PATHS)}
            >
                <span onClick={onStationClick} onMouseEnter={onDescriptionExpand} onMouseLeave={onDescriptionCollapse}>
                    <StationIcon type={type} isHighlight={isDescriptionExpanded || station.isSelectedStation(selectedStation)} />
                </span>
                <SubZoneExpandIcon onClick={onExpandSubzone} data-testid="subzone-expand" className="station-expand-trigger-element">
                    <Coaching />
                </SubZoneExpandIcon>
            </SubZoneIconWrapper>
            <Description
                onDescriptionExpand={onDescriptionExpand}
                onDescriptionCollapse={onDescriptionCollapse}
                station={station}
                isActiveStation={stationStatus === StationStatus.ACTIVE_STATION}
                onClick={onStationClick}
            />
            {timeline ? <TimelineWrapper textVariant="body3">{timeline}</TimelineWrapper> : null}
        </SubZoneStationWrapper>
    );
};
